export {newGovoltePlugin} from './govoltePlugin';
export type {GovoltePlugin, GovoltePluginOptions} from './govoltePlugin';
